/**
 * Users API endpoints — T20.
 * Maps PRD §9.2 to typed fetch calls via apiClient.
 */
import {
  type CreateUserRequest,
  ListUsersResponseSchema,
  type UpdateUserRequest,
  UserResponseSchema,
} from '@malaberg/shared';
import { apiClient } from '../client';

export interface ListUsersQuery {
  status?: 'active' | 'inactive';
  role?: 'writer' | 'admin' | 'system_owner';
  limit?: number;
  offset?: number;
}

function toQueryString(params: Record<string, string | number | undefined>): string {
  const entries = Object.entries(params).filter(([, v]) => v !== undefined);
  if (entries.length === 0) return '';
  return `?${entries.map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`).join('&')}`;
}

export const usersApi = {
  list(query: ListUsersQuery = {}) {
    return apiClient.request(
      'GET',
      `/api/users${toQueryString(query as Record<string, string | number | undefined>)}`,
      {
        schema: ListUsersResponseSchema,
      }
    );
  },

  get(id: string) {
    return apiClient.request('GET', `/api/users/${id}`, {
      schema: UserResponseSchema,
    });
  },

  create(body: CreateUserRequest) {
    return apiClient.request('POST', '/api/users', {
      body: JSON.stringify(body),
    });
  },

  update(id: string, body: UpdateUserRequest) {
    return apiClient.request('PATCH', `/api/users/${id}`, {
      body: JSON.stringify(body),
    });
  },

  resetPassword(id: string) {
    return apiClient.request('POST', `/api/users/${id}/reset-password`, {
      body: JSON.stringify({}),
    });
  },

  impersonate(id: string) {
    return apiClient.request('POST', `/api/users/${id}/impersonate`, {
      body: JSON.stringify({}),
    });
  },

  stopImpersonation(id: string) {
    return apiClient.request('POST', `/api/users/${id}/impersonate/stop`, {
      body: JSON.stringify({}),
    });
  },
};
